import { Box, Button, Dialog, Flex, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import { useTransactions } from '../transactions.provider';

const renderValue = (value: string | number | null | undefined) => value ?? '-';

const formatPrice = (price: number | null) => {
   if (price === null || Number.isNaN(Number(price))) {
      return '0';
   }

   return new Intl.NumberFormat('uk-UA').format(price);
};

const DetailRow = ({ label, value }: { label: string; value: string | number }) => (
   <Flex gap="3" align="start" className="transactions__detail-row">
      <Text size="3" color="gray" className="transactions__detail-label">
         {label}
      </Text>
      <Text size="3" weight="medium">
         {value}
      </Text>
   </Flex>
);

const TransactionDetailsDialogView = () => {
   const transactionsStore = useTransactions();
   const selectedTransaction = transactionsStore.selectedTransaction;

   return (
      <Dialog.Root
         open={Boolean(selectedTransaction)}
         onOpenChange={(open) => {
            if (!open) {
               transactionsStore.closeTransactionDialog();
            }
         }}
      >
         <Dialog.Content aria-describedby={undefined} maxWidth="620px">
            {selectedTransaction && (
               <Flex direction="column" gap="4">
                  <Dialog.Title>
                     Transaction ID - {renderValue(selectedTransaction.transaction_id)}
                  </Dialog.Title>

                  <Flex direction="column" gap="3" className="transactions__details">
                     <DetailRow
                        label="Plan Name"
                        value={renderValue(selectedTransaction.plan_name)}
                     />
                     <DetailRow label="Amount" value={formatPrice(selectedTransaction.price)} />
                     <DetailRow
                        label="Transaction ID"
                        value={renderValue(selectedTransaction.transaction_id)}
                     />
                     <DetailRow
                        label="Start Date"
                        value={renderValue(selectedTransaction.start_date)}
                     />
                     <DetailRow
                        label="End Date"
                        value={renderValue(selectedTransaction.end_date)}
                     />
                     <Box>
                        <Text as="div" size="3" color="gray" mb="1">
                           Features
                        </Text>
                        <Flex direction="column" gap="1">
                           {selectedTransaction.features?.length ? (
                              selectedTransaction.features.map((feature, index) => (
                                 <Text key={`${selectedTransaction.id}-feature-${index}`} size="3">
                                    {index + 1}. {feature}
                                 </Text>
                              ))
                           ) : (
                              <Text size="3">-</Text>
                           )}
                        </Flex>
                     </Box>
                  </Flex>

                  <Flex justify="end">
                     <Dialog.Close>
                        <Button size="3" variant="soft" color="gray">
                           Close
                        </Button>
                     </Dialog.Close>
                  </Flex>
               </Flex>
            )}
         </Dialog.Content>
      </Dialog.Root>
   );
};

export const TransactionDetailsDialog = observer(TransactionDetailsDialogView);
